import React from 'react'
import Back from '../../common/Back'
import PriceCard from '../Home/Price/PriceCard'
import i from '../images/1.jpg'
const Pricing = () => {
  return (
    <>
       <section className="services mb">
        <Back name='30 days money back guarantee' title='No Extra Fees. Friendly Support' cover={i} />
        <div className="container price">
            <PriceCard/>
        </div>
      </section>
    </>
  )
}

export default Pricing
